module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    staticClass: "pull-right"
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "primary",
      "title": "Categorie toevoegen",
      "exact": "",
      "to": {
        name: 'categoryAdd'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus"
  })]), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-secondary",
      "title": "Terug",
      "exact": "",
      "to": {
        name: 'Landingpage'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reply"
  })])], 1), _vm._v(" "), _c('h1', {
    staticClass: "display-4"
  }, [_vm._v("Categorieën beheer")]), _vm._v(" "), (_vm.error) ? _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('b-pagination-nav', {
    attrs: {
      "link-gen": _vm.linkGen,
      "number-of-pages": _vm.categories.last_page,
      "value": _vm.categories.current_page,
      "use-router": "",
      "align": "right"
    }
  })], 1)]), _vm._v(" "), _c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  }), _vm._v(" "), (!_vm.isFetching) ? _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "show-empty": "",
      "items": _vm.categories.data,
      "fields": _vm.fields,
      "per-page": parseInt(_vm.categories.per_page),
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "busy": _vm.isFetching,
      "empty-text": _vm.$t('category.listEmptyText'),
      "empty-filtered-text": _vm.$t('category.listEmptyFilteredText')
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "cell(auction_date)",
      fn: function(row) {
        return [(row.item.auction_date) ? [_vm._v(_vm._s(_vm._f("smallDate")(row.item.auction_date)))] : [_vm._v(" - ")]]
      }
    }, {
      key: "cell(actions)",
      fn: function(row) {
        return [_c('b-btn-group', {
          staticClass: "pull-right"
        }, [_c('b-btn', {
          attrs: {
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              return _vm.showDeleteModal(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-trash"
        })]), _vm._v(" "), _c('b-btn', {
          attrs: {
            "variant": "outline-primary",
            "to": {
              name: 'categoryEdit',
              params: {
                categoryId: row.item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-fw fa-edit"
        })])], 1)]
      }
    }], null, false, 2165058508)
  }) : _vm._e(), _vm._v(" "), _c('b-pagination-nav', {
    attrs: {
      "link-gen": _vm.linkGen,
      "number-of-pages": _vm.categories.last_page,
      "value": _vm.categories.current_page,
      "use-router": "",
      "align": "right"
    }
  }), _vm._v(" "), _c('delete-dialog-modal', {
    ref: "deleteModal",
    attrs: {
      "delete-name": _vm.selectedDeleteCategoryName,
      "item": _vm.selectedDeleteCategory,
      "isDeleting": _vm.isDeleting
    },
    on: {
      "confirm": _vm.deleteCategory
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46b214c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Category/CategoryList.vue
// module id = 1305
// module chunks = 1